// @ngInject
Filters.HbToLocaleAmount = function HbToLocaleAmount($filter) {
    return function (text) {
        return !isNaN(Number(text)) ? Number(text).toLocaleString() : text;
    };
};